import { render, staticRenderFns } from "./pattern.vue?vue&type=template&id=5b5bd517&"
import script from "./pattern.vue?vue&type=script&lang=js&"
export * from "./pattern.vue?vue&type=script&lang=js&"
import style0 from "./pattern.vue?vue&type=style&index=0&id=5b5bd517&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.0_m252fu66fivcrdajfhoxhvxrne/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports